import { useCallback, useRef } from 'react';

export function useStartTyping({ onStartTyping }: { onStartTyping?: () => void }) {
    const typing = useRef(false);

    const handleChange = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>) => {
            if (!typing.current && !!ev.target.value) {
                onStartTyping?.();
                typing.current = true;
            }
        },
        [onStartTyping],
    );

    const handleBlur = useCallback(() => {
        typing.current = false;
    }, []);

    return {
        handleBlur,
        handleChange,
    };
}
